var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeInstructions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:document-bold"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78133 2.11459C2 2.89525 2 4.15259 2 6.66659V9.33325C2 11.8473 2 13.1046 2.78133 13.8853C3.562 14.6666 4.81933 14.6666 7.33333 14.6666H8.66667C11.1807 14.6666 12.438 14.6666 13.2187 13.8853C14 13.1046 14 11.8473 14 9.33325V6.66659C14 4.15259 14 2.89525 13.2187 2.11459C12.438 1.33325 11.1807 1.33325 8.66667 1.33325H7.33333C4.81933 1.33325 3.562 1.33325 2.78133 2.11459ZM5.33333 6.16659C5.20073 6.16659 5.07355 6.21926 4.97978 6.31303C4.88601 6.4068 4.83333 6.53398 4.83333 6.66659C4.83333 6.79919 4.88601 6.92637 4.97978 7.02014C5.07355 7.11391 5.20073 7.16659 5.33333 7.16659H10.6667C10.7993 7.16659 10.9265 7.11391 11.0202 7.02014C11.114 6.92637 11.1667 6.79919 11.1667 6.66659C11.1667 6.53398 11.114 6.4068 11.0202 6.31303C10.9265 6.21926 10.7993 6.16659 10.6667 6.16659H5.33333ZM5.33333 8.83325C5.20073 8.83325 5.07355 8.88593 4.97978 8.9797C4.88601 9.07347 4.83333 9.20064 4.83333 9.33325C4.83333 9.46586 4.88601 9.59304 4.97978 9.68681C5.07355 9.78057 5.20073 9.83325 5.33333 9.83325H8.66667C8.79927 9.83325 8.92645 9.78057 9.02022 9.68681C9.11399 9.59304 9.16667 9.46586 9.16667 9.33325C9.16667 9.20064 9.11399 9.07347 9.02022 8.9797C8.92645 8.88593 8.79927 8.83325 8.66667 8.83325H5.33333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeInstructions);
export default __webpack_public_path__ + "static/media/CodeInstructions.809bff7e3efc8f4b4d13cd8e5e257aa3.svg";
export { ForwardRef as ReactComponent };